export const Collaborationmodules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};

export const Collaborationformats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

export const maximizePopUpout = {
  display: 'block',
  position: 'fixed',
  zIndex: '10',
  // paddingTop: '50px',
  // left: '155px',
  top: '25px',
  width: '72%',
  height: '91%',
  overflow: 'auto',
  backgroundColor: '#fff',
  borderRadius: '10px',
  border: '1px solid black'

}
export const maximizePopUpIn = {
  backgroundColor: '#fefefe',
  margin: 'auto',
  padding: '20px',
  border: '0px solid #888',
  width: '750px'

}
export const minimizePopUpout = {
  display: 'block',
  // position: 'absolute',
  // zIndex: '1',
  // bottom: '20px',
  // right: '20px',
  width: '315px',
  height: '250px',
  overflow: 'auto',
  // backgroundColor: '#f5b3b300',
  backgroundColor: 'rgba(245, 245, 251, 0.8)',
  border: '2px solid rgb(78, 86, 148)',
  borderRadius: '15px'
}
export const minimizePopUpIn = {
  backgroundColor: 'black',
  margin: 'auto',
  padding: '20px',
  border: '0px solid rgb(136, 136, 136)',
  width: '250px',
  height: '95px',
  borderRadius: '11px'
}
export const MinMaxButton = {
  float: "right",
  width: '35px',
  height: "28px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background:'none',
  border:'none'
}
